import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from "@common/hooks/translation";

import './style.scss';

const Tabs = ({ options, value, onChange }) => {
  const t = useTranslation();

  return (
    <div className="tabs">
      {options.map((option) => (
        <div
          key={option.value}
          className={`tab-wrapper ${option.value === value ? 'active-tab' : ''}`}
        >
          <div onClick={() => onChange?.(option)}>
            {t(option.name)}
          </div>
        </div>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default Tabs;